export default __webpack_public_path__ + "static/media/ad_3.015bf273.mp3";